import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";

const config = {
    name: {
        // field
        label: "Название",
        inputProps: { name: "name" },
        validators: [requiredField],
        required: true,
    },
    planStayPeriod: {
        // field
        label: "Период ожидания",
        inputProps: { name: "planStayPeriod", type: "number" },
        validators: [requiredField],
        required: true,
    },
    isVisitOptional: {
        // field
        label: "Необязательное посещение",
        inputProps: { name: "isVisitOptional", type: "checkbox" },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
